<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Technician Services"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Add technician services."
      @on-submit="createTechnicianServiceImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Technician Services Template.xlsx"
              :file-provider="$importsAPI.getTechnicianServicesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianServicesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'technician-services-imports-add-modal',
    };
  },
  methods: {
    createTechnicianServiceImport(data, handleCreate) {
      handleCreate(this.$importsAPI.technicianServicesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
